"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringSeparator;
(function (StringSeparator) {
    StringSeparator["Dot"] = ".";
    StringSeparator["Comma"] = ",";
})(StringSeparator = exports.StringSeparator || (exports.StringSeparator = {}));
